import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton, FlexStack, Spinner } from '~/components/atomic';
import { breakpoint } from '~/styles/themes';

interface GenerateLoadingProps {
  handleCancelClick: () => void;
}

export default function GenerateLoading({
  handleCancelClick,
}: GenerateLoadingProps) {
  useEffect(() => {
    document.body.classList.add('block');
    return () => {
      document.body.classList.remove('block');
    };
  }, []);

  return createPortal(
    <Container>
      <StyledFlexStack spacing={26}>
        <div
          css={css`
            color: #04e1ff;
          `}
        >
          <Spinner size='xLarge' thickness='bold' />
        </div>
        <StyledFlexStack spacing={16}>
          <Title>Making your Character...</Title>
          <Description>It takes a few minutes.</Description>
        </StyledFlexStack>
      </StyledFlexStack>
      <BottomButtonWrapper>
        <DefaultButton colorType='black' onClick={handleCancelClick}>
          Cancel
        </DefaultButton>
      </BottomButtonWrapper>
    </Container>,
    document.body,
  );
}
const Container = styled.div`
  display: flex;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 1);
`;

const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.title.section24_bold};
  `}
`;

const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

const StyledFlexStack = styled(FlexStack)`
  align-items: center;
`;

const BottomButtonWrapper = styled(FlexStack)`
  position: absolute;
  bottom: 40px;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  padding: 16px;
`;
